import React from "react";
import "./ElectricGrid.css";


function ElectricGrid({

  x = 100,
  y = 100,
  width = 200,
  height = 150,

  state = "STOP"

}) {


const active = state === "START" || state === "PAUSE";


return (

<div

className="electric-grid-container"

style={{

position:"absolute",

left:x,

top:y,

width,

height

}}

>


<svg

width={width}

height={height}

viewBox="0 0 160 120"

>


{/* ======================
    HORIZONTAL BARS
====================== */}


<line

className={active ? "energy-flow" : ""}

x1="20"
y1="25"
x2="140"
y2="25"

/>


<line

className={active ? "energy-flow" : ""}

x1="20"
y1="60"
x2="140"
y2="60"

/>


<line

className={active ? "energy-flow" : ""}

x1="20"
y1="95"
x2="140"
y2="95"

/>



{/* ======================
    VERTICAL BARS
====================== */}


<line

className={active ? "energy-flow" : ""}

x1="35"
y1="15"
x2="35"
y2="105"

/>


<line

className={active ? "energy-flow" : ""}

x1="65"
y1="15"
x2="65"
y2="105"

/>


<line

className={active ? "energy-flow" : ""}

x1="95"
y1="15"
x2="95"
y2="105"

/>


<line

className={active ? "energy-flow" : ""}

x1="125"
y1="15"
x2="125"
y2="105"

/>



</svg>



</div>


);

}


export default ElectricGrid;